<template>
  <div>
    <l-table :tableConfig="tableConfig" ref="table">
      <!-- <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" placeholder="请输入课程名称">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img
            class="clear"
            v-if="keyword"
            slot="suffix"
            @click=";(keyword = undefined), search()"
            :src="require('@/assets/icons/icon_gb.png')"
          />
        </a-input>
      </template> -->
      <template slot="searchActions"> </template>
      <template #reviewStatus="{ record }">
        {{
          record.reviewStatus === '1'
            ? $t('courseReviewManagement.draft')
            : record.reviewStatus === '2'
            ? $t('courseReviewManagement.pending')
            : record.reviewStatus === '3'
            ? $t('courseReviewManagement.rejected')
            : record.reviewStatus === '4'
            ? $t('courseReviewManagement.approved')
            : '-'
        }}
      </template>
      <template #archiveStatus="{ record }">
        {{ record.archiveStatus === '1' ? $t('courseReviewManagement.unarchive') : record.archiveStatus === '2' ? $t('courseReviewManagement.archive') : '-' }}
      </template>
      <template #operates="{ record }">
        <div>
          <a-button
            type="link"
            :disabled="record.reviewStatus !== '2'"
            style="padding-right: 0"
            @click="approve(record)"
          >
            {{ $t('courseReviewManagement.review') }}
          </a-button>
          <a-button type="link" style="padding-right: 0" @click="set(record)" :disabled="record.reviewStatus !== '4'">
            {{ $t('courseReviewManagement.setting') }}
          </a-button>
          <a-button
            type="link"
            style="padding-right: 0"
            @click="
              delVisible = true
              delId = record.id
            "
          >
            {{ $t('courseReviewManagement.delete') }}
          </a-button>
        </div>
      </template>
    </l-table>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
          <p>${$t('courseReviewManagement.confirmDelete')}</p>
          <p class='placeholder'>${$t('courseReviewManagement.deleteWarning')}</p>`
      "
    />
  </div>
</template>

<script>
import TipModal from '@/components/tipModal/index.vue'
import LTable from '@/components/LTable/index.vue'
import { courseReviewList, courseReviewDel } from '@/api/admin'

export default {
  components: {
    LTable,
    TipModal
  },
  data() {
    return {
      keyword: undefined,
      tableConfig: {
        tableName: this.$t('courseReviewManagement.tableName'),
        tableColumns: [
          {
            title: this.$t('courseReviewManagement.teacher'),
            dataIndex: 'teacherName',
            key: 'teacherName',
            align: 'center'
          },
          {
            title: this.$t('courseReviewManagement.courseName'),
            dataIndex: 'lessonName',
            key: 'lessonName',
            align: 'center'
          },
          {
            title: this.$t('courseReviewManagement.profession'),
            dataIndex: 'professionName',
            key: 'professionName',
            align: 'center'
          },
          {
            title: this.$t('courseReviewManagement.reviewStatus'),
            dataIndex: 'reviewStatus',
            key: 'reviewStatus',
            align: 'center',
            scopedSlots: { customRender: 'reviewStatus' }
          },
          {
            title: this.$t('courseReviewManagement.courseStatus'),
            dataIndex: 'archiveStatus',
            key: 'archiveStatus',
            align: 'center',
            scopedSlots: { customRender: 'archiveStatus' }
          },
          {
            title: this.$t('courseReviewManagement.submitTime'),
            dataIndex: 'submitTime',
            key: 'submitTime',
            align: 'center'
          },
          {
            title: this.$t('courseReviewManagement.operation'),
            dataIndex: 'operates',
            key: 'operates',
            align: 'center',
            width: 240,
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('courseReviewManagement.deleteConfirmTitle'),
          content: this.$t('courseReviewManagement.deleteConfirmContent')
        },
        tablePort: {
          list: '/portal-lesson-apply/list',
          del: '/portal-lesson-apply/delete'
        },
        tableData: []
      },
      delVisible: false,
      delId: undefined
    }
  },
  methods: {
    search() {},
    create() {
      this.$router.push({
        name: 'teacherAdd'
      })
    },
    approve(record) {
      this.$router.push({
        name: 'courseToReviewer',
        query: {
          id: record.id
        }
      })
    },
    set(record) {
      this.$router.push({
        name: 'courseSet',
        query: {
          id: record.id
        }
      })
    },
    getCourseReviewList() {
      courseReviewList().then(res => {
        this.tableConfig.tableData = res.data
      })
    },
    del() {
      courseReviewDel({
        id: this.delId
      }).then(res => {
        if (res.code === 200) {
          this.delVisible = false
          this.getCourseReviewList()
          this.$message.success(this.$t('courseReviewManagement.deleteSuccess'))
          this.$refs.table.getList()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
